import { useLoader } from "@/pinia/useLoader";

export default defineNuxtRouteMiddleware(() => {
    const { startLoading, stopLoading } = useLoader();
    startLoading();
    setTimeout(() => {
        stopLoading();
    }, 1000);
})